import assetPath from '/opt/actions-runner/_work/crate/crate/packages/lebenslauf/articles/src/assets/der-ultimative-leitfaden-fuer-deine-online-bewerbung-1.jpeg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')